<template>
    <div>
        <div v-if="isReportFeatureVisible">
            <CCol sm="12" class="bg-FAFAFA">
                <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
                    <br /> <br />
                        <CRow class="m-2">
                            <CCol sm="12">
                                <h3 class="custom-40px-500 text-center mt-0">Detailed Candidate Interview Videos</h3>
                                <p class="custom-18px-400 text-center m-2">Empower your company with seamless access to detailed interview videos, <br /> enabling comprehensive evaluation of candidate qualifications and suitability for the role</p>
                            </CCol>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="10">
                                        <CInput type="text" placeholder="Search Candidate" v-model="searchQuery" />
                                    </CCol>
                                    <CCol sm="2">
                                        <CSelect>
                                            <CSelect label="Sort By" :options="['Sort By',2,3,4,5,6,7,8,9,10,11,12]" />
                                        </CSelect>
                                    </CCol>
        
                                </CRow>
                                <template v-if="Busy == true">
                                <div class="container text-center">
                                <pulse-loader
                                    :loading="loading"
                                    :color="color"
                                    :size="size"
                                ></pulse-loader>
                                </div>
                                </template>
                                <table class="table table-responsive-sm table-hover table-outline mb-0 mt-3 ml-15 mr-15" style="border:none">
                                    <thead class="bg-f7f7f7 b-20">
                                        <th> <label class="custom-12px-700"><input type="checkbox" class="mr-2"/>Candidate Name</label></th>
                            
                                        <th><label class="custom-12px-700">Email</label></th>
                                        <th><label class="custom-12px-700">Interview</label></th>
                                        <th><label class="custom-12px-700"></label></th>
                                    </thead>

                                    <tbody>
                                        <tr v-for="(item, index) in filteredList" :key="item.videoId">
                                            <td>
                                            {{ item.sessionId }}
                                                <input type="checkbox" class="mr-2" />
                                                <img v-if="item.profilePhoto" :src="item.profilePhoto" width="30px" height="30px" style="border-radius: 50%; border: 1px solid #fff; object-fit: cover;" />
                                                <img v-else src="../assets/img/2-2.png" width="30px" height="30px" style="border-radius: 50%; border: 1px solid #fff; object-fit: cover;" />
                                                <label class="custom-12px-500 ml-2">{{ item.name }}</label>
                                            </td>
                                            <td>
                                                <label class="custom-12px-700"> {{ item.email }}</label>
                                            </td>
                                            <td>
                                                <label class="custom-12px-700"> {{ item.sessionName }}</label>
                                            </td>
                                            <td>
                                                <label class="custom-border-purple p-2 mr-5 text-white" @click="InsertReport(item, item.originalIndex)">
                                                    {{ selectedRowIndex === item.originalIndex ? 'Processing...' : item.uploadStatus }}
                                                </label>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
        
                            </CCol>
        
                        </CRow>
                    <br /><br /><br />
                </CCol>
        
            

                <div v-if="ispopupVisible3" class="popup-all backdrop-all">
                    <div class="popup-all1">
                        <!-- Popup content -->
                        <div class="text-center">
                            <img style="max-width: 100px" src="../assets/img/confirm.png" />
                            <h3 class="custom-18px text-center mt-3">
                                Are you sure want to generate report for <br /> {{ sessionUser }} ?
                            </h3>
                            <div class="mt-4">
                                <label class="custom-grey-radius ml-2 font-color-171717 mr-4" @click="InsertReport(sessionId)" style="width:100px">Yes</label>
                                <label class="custom-border-purple p-2 text-center mr-2" @click="closePopup2()" style="width:100px">Cancel</label>
                            </div>
                        </div>
        
                    </div>
                </div>

                <div v-if="isSuccess" class="popup-all backdrop-all">
                    <div class="popup-all1">
                        <!-- Popup content -->
                        <div class="text-center">
                            <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                            <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                                Generate Successfully
                            </h3>
                            <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                        </div>
                    </div>
                </div>
        
            </CCol>
        </div>
        <div v-else>
            <div v-if="isPopupError">
                <div class="popup-all1">
                        <!-- Popup content -->
                        <div class="text-center">
                            <img style="max-width: 100px" src="../assets/img/error.png" />
                            <h3 class="custom-32px-500 text-center mt-3 font-color-171717">
                               Ooops!
                            </h3>
                            <h3 class="custom-18px text-center mt-3">
                                You don’t have permission to access this page. Please contact your administrator or check your account settings.
                            </h3>
                        </div>
        
                    </div>
            </div>
            <br /> <br /> <br />
        </div>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartDoughnut } from '@coreui/vue-chartjs';
import { CCol } from '@coreui/vue';

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        PulseLoader,
        CChartDoughnut,
        CCol
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrNoArrow,
            ispopupVisible2: false,
            ispopupVisible3: false,
            list: [],
            user: {},
            videoUrl: '',
            searchQuery: '',

            questionVideo: {},
            Busy: false,
            sessionUser: "",
            sessionDelete: "",
            isSuccess: false,
            uploadStatus: "Generate Report",
            size: "",
            color: "",
            loading: "",
            selectedRowIndex: null,
            features:[],
            isPopupError: true
            
        };
    },
    created() {},
    computed: {
        filteredList() {
            const query = this.searchQuery.toLowerCase().trim();

            return this.list
                .map((item, originalIndex) => ({
                    ...item,
                    originalIndex
                }))
                .filter(item => {
                    const matchesQuery = query ? item.name.toLowerCase().includes(query) : true;
                    const hasRelevantSessionDetails = item.SessionDetails &&
                        item.SessionDetails.length > 0 &&
                        item.SessionDetails.some(detail => detail.indexNo === 1 && detail.url !== "No recorded video.");
                    return matchesQuery && hasRelevantSessionDetails;
                });
        },
        defaultDatasets() {
            return [{
                backgroundColor: [

                    '#928AFD'
                ],
                data: [100]
            }]
        
        },
        isReportFeatureVisible() {
            // Check if the user has access to the Blog feature in the "Page" group
            return Array.isArray(this.features) && this.features.filter(f => f.FeaturesGroup === "Page" && f.FeaturesType === "Report" && f.IsVisible).length > 0;
        }
    },
    async mounted() {
        try {
        const isAuth = await this.UserAuth();
        if (isAuth) {
            await this.getFeatures();
            await this.GetInfoUser(); // Fetch the user details first
                await this.getListVideo(); // Ensure this is awaited
               
                // Set uploadStatus to "pending" after fetching the list
        } else {
            this.GoToLogin();
        }
    } catch (error) {
        console.error("Error during authentication:", error);
        // Handle the error here
    }

    },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async getListVideo() {

            try {
                this.Busy = true;
                const response = await this.$API.get(this.$GetListReportNotGenerate);
                if (response.status === 200) {
                    this.Busy = false;
                    this.list = response.data.map(item => ({ ...item, uploadStatus: "Generate Report" }));
                    this.photoURL = this.list.profilePhoto;
                 
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },

        closePopup1() {
            this.ispopupVisible2 = false;
        },
        OpenPopup() {
            this.ispopupVisible2 = true;
        },
        OpenForm() {
            this.ispopupVisible2 = false;
            this.ispopupVisible3 = true;

        },
        closePopup2() {
            this.ispopupVisible3 = false;
        },
        closeSuccess()
        {
            this.isSuccess = false;
        },

        openVideoPopup(item) {
            //console.log("video" + url);
            // this.videoUrl = url;
            this.sessionId = item.sessionId;
            this.sessionUser = item.name;
            this.ispopupVisible3 = true;
        },

        // Method to close the video popup
        closeVideoPopup() {
            this.isPopupVisible3 = false;
            // Optionally, you can clear the video URL when the popup is closed
            // this.videoUrl = '';
        },
        async InsertReport(item, originalIndex) {
            console.log("Clicked index:", originalIndex, "Item:", item);

            this.$set(this.list, originalIndex, {
                ...this.list[originalIndex],
                uploadStatus: 'Processing...'
            });

            await this.$nextTick();

            try {
                const response = await this.$API.get(`${this.$GenerateReport}?session_id=${item.sessionId}`);
                if (response.status === 200) {
                    this.$set(this.list, originalIndex, {
                        ...this.list[originalIndex],
                        uploadStatus: 'Complete'
                    });
                    this.isSuccess = true;
                } else {
                    this.$set(this.list, originalIndex, {
                        ...this.list[originalIndex],
                        uploadStatus: 'Generate Report'
                    });
                }
            } catch (error) {
                console.error("Error generating report:", error);
                this.$set(this.list, originalIndex, {
                    ...this.list[originalIndex],
                    uploadStatus: 'Generate Report'
                });
            }
        },
        async getFeatures() {
            try {
                const response = await this.$API.get(this.$GetFeatures, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.features = response.data;
                } else {
                    console.error(`Unexpected response status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching features:', error);
            }
        },





       
       
       
    }

};
</script>

<style scoped>
.watermark {
    position: absolute;
    top: 24%;
    left: 25%;
    transform: rotate(-40deg);
    font-size: 80px;
    color: rgba(0, 0, 0, 0.1);
    /* Adjust opacity as needed */
    pointer-events: none;
    /* Make sure the watermark doesn't interfere with other elements */
    z-index: 1;
}
</style>
